// extracted by mini-css-extract-plugin
export default {"wrap":"conjugate_wrap__ptsV-","progress":"conjugate_progress__saRU-","loading":"conjugate_loading__4AtL-","loadingAni":"conjugate_loadingAni__RwzrF","error":"conjugate_error__xsz+9"};